import { PLATFORM } from 'scenes/Campaigns/components/Form/constants';

import {
  FRAUD_PROTECTION_OS_VERSION_VALUE,
  FRAUD_PROTECTION_OS_VERSION_MAX_VALUE,
  FRAUD_PROTECTION_DEVICE_TYPE,
} from './constants';

export function getFraudDependencies() {
  return {
    [FRAUD_PROTECTION_OS_VERSION_VALUE]: [PLATFORM],
    [FRAUD_PROTECTION_OS_VERSION_MAX_VALUE]: [PLATFORM],
    [FRAUD_PROTECTION_DEVICE_TYPE]: [PLATFORM],
  };
}
